import { css } from 'styled-components'

const transparentButtonTemplate = () => css`
  background: transparent;
  color: var(--sl-fg-base-disabled);

  min-width: unset;
  height: auto;
  padding: 0.125rem 0.25rem;

  &:not(:disabled) {
    &:hover {
      color: var(--sl-fg-base);
    }
  }
`

export default transparentButtonTemplate
